import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { HashLink } from "react-router-hash-link";
import { db, doc, setDoc } from "../../firebase";

export default function AdminAProduct({ pro, currentCountry }) {
  const { t, i18n } = useTranslation();
  const [product, setProduct] = useState(null); //product in context

  const [quantity, setQuantity] = useState(pro.quantity);
  const [stop, setStop] = useState(false);

  const changeQuantity = (e, id) => {
    e.preventDefault();

    console.log("quantity", quantity);
    console.log("stop", stop);
    console.log("id", id);

    if (!/^[0-9999999]+$/.test(quantity)) {
      alert("Please only enter number only for your Quantity. ");
    } else {
      console.log("HI");
      const ref = doc(
        db,
        currentCountry === "US" ? "products" : "KO_products",
        id
      );
      setDoc(
        ref,
        { quantity: quantity, stop: stop === "Stop" ? "true" : "false" },
        { merge: true }
      ).then((res) => {
        alert(t(pro.name) + "의 변경사항이 저장되었습니다.");
        window.location.reload();
      });
      //   alert("The updates was successful.");
      //   window.location.reload();
    }
  };
  // console.log(product?.productId, product?.title, product);
  return (
    <Card sx={{ width: 300, mb: 2 }}>
      {/* <form onSubmit={(e) => changeQuantity(e, pro.id)}> */}
      <CardMedia
        component="img"
        alt="green iguana"
        height="140"
        image={pro.img}
        sx={{ objectFit: "contain", pt: 2 }}
      />
      <CardContent sx={{ textAlign: "center" }}>
        <Typography
          gutterBottom
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            mt: 2,
            backgroundColor: "#e7ebef",
            width: "fit-content",
            px: 1,
            ml: "auto",
            mr: "auto",
            mb: 2,
          }}
          component="div"
        >
          {t(pro.title)}
        </Typography>
        <div>제품 넘버: {pro?.productId}</div>
        <div style={{ paddingTop: "15px" }}>
          현재 상품 재고량: {pro.quantity}개
        </div>
        <div style={{ marginTop: "10px" }}>
          상품 재고량 변경:&nbsp;&nbsp;
          <input
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            type="text"
            name="newQuantity"
            style={{
              borderRadius: "3px",
              width: "100px",
              border: "1px solid lightgray",
              paddingTop: "10px",
              paddingBottom: "10px",
            }}
          />
        </div>
        <div style={{ marginTop: "10px" }}>
          판매 상태:{" "}
          {pro.stop === "true" ? (
            <span style={{ color: "red" }}>판매 중지 중</span>
          ) : (
            <span style={{ color: "green" }}>판매중</span>
          )}
        </div>
        <div
          style={{
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            // marginLeft: "20px",
            justifyContent: "center",
          }}
        >
          판매 중지 상태 변경:&nbsp;&nbsp;
          <select
            style={{
              width: "100px",
              borderRadius: "3px",
              border: "1px solid lightgray",
              paddingTop: "10px",
              paddingBottom: "10px",
            }}
            onChange={(e) => setStop(e.target.value)}
          >
            <option value={"Continue"}>{t("Continue Selling")}</option>
            <option value={"Stop"}>{t("Stop Selling")}</option>
          </select>
        </div>
        <div style={{ lineHeight: "2.1em", paddingTop: "10px" }}>
          <div>한국 Price: {pro?.price_KO}원</div>
          <div>US Price: ${pro?.price_US}</div>
          <div>Volumn: {pro?.volumn}</div>
        </div>
      </CardContent>
      <CardActions sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
        <Button
          type="submit"
          size="small"
          onClick={(e) => changeQuantity(e, pro.id)}
          sx={{ color: "#1876d1", fontSize: "11px" }}
        >
          {t("Save The Change")}
        </Button>
        {/* http://localhost:3001/product/pet-spray */}
        <HashLink smooth to={"/product/" + pro?.linkTo + "#top"}>
          <Button size="small" sx={{ color: "#1876d1", fontSize: "11px" }}>
            {t("go to Page")}
          </Button>
        </HashLink>
      </CardActions>
      {/* </form> */}
    </Card>
  );
}
